import { useAppContext } from "../../context/AppContext";
import { DaysOfTheWeekTrans, OnlineSessionsTrans, ScheduleDetailsTrans, ToasterTrans } from "../../utils/translations";
import bgImg from "../../assets/images/bgImg-1.png";
import CalendarComponent from "../Calendar";
import { useEffect, useState } from "react";
import { getSchedule } from "../../services/scheduleService";
import SetmoreBooking from "../SetmoreBooking";
import { trackPixelEvent } from "../../utils/pixel";

export default function Offline() {
  const { language, user, setToaster, token } = useAppContext();
  const highlightedDate = new Date(2024, 11, 16);
  const details = ScheduleDetailsTrans[language];
  const [schedule, setSchedule] = useState([]);

  const englishZoom = "";
  const russianZoom = "https://us04web.zoom.us/j/72392142849?pwd=bLWaSk11zVTMsWs9R7rbpGkPYpVAN0.1";

  useEffect(() => {
    if (!schedule.length) {
      (async () => {
        const fetchedSchedule = await getSchedule();
        setSchedule(fetchedSchedule);
      })();
    }
  }, [schedule.length]);

  return (
    <main className="flex min-h-screen flex-col">
      <div className="h-[55vh] w-full overflow-hidden">
        <img
          // src={isMobile ? PricesMobile : Prices}
          src={bgImg}
          alt="Description"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="w-10/12 mx-auto mb-16">
        <h1>{OnlineSessionsTrans[language].header}</h1>
        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-10 mt-10 h-fit w-full mx-auto relative">
          {/* Left Half - Live Lessons */}
          <div className="flex flex-col items-center h-full text-xl sm:w-5/6 mx-auto">
            <div className="text-center">{OnlineSessionsTrans[language].liveLessons}</div>
            <div className="bg-beige rounded-3xl mt-5 w-full max-w-sm">
              <div className="bg-white m-4 p-7 rounded-3xl">
                {/* Morning Practice */}
                <div className="text-center mb-5 w-full lg:w-4/5 mx-auto">
                  <h1 className="text-xl font-medium border-b-[1px] border-lightGray mx-auto">
                    {details.morningPracticeHeader}
                  </h1>
                  {schedule?.[language]?.offline?.sessions?.morning ?  <>
                      <p className="text-base">
                        {schedule[language].offline.sessions.morning?.days
                          ?.map(
                            (day, index) =>
                              <>
                                {day}
                                <ul className="mt-1 space-y-1 w-5/6 mx-auto">
                                  <li
                                    key={index}
                                    className="flex justify-between text-sm font-semibold"
                                  >
                                    <span>
                                      {schedule[language].offline.sessions.morning?.times?.[index].start}-{schedule[language].offline.sessions.morning?.times?.[index].end}
                                    </span>
                                    <span>
                                      {
                                        schedule[language].offline.sessions.morning?.times?.[index].activity

                                      }
                                    </span>
                                  </li>
                                </ul>
                              </>
                            //  DaysOfTheWeekTrans[language]?.[day] || day
                          )}
                      </p>
                    </>
                   : (
                    <p className="text-base">{ToasterTrans[language].comingSoon}</p>
                  )}
                </div>

                {/* Evening Practice */}
                <div className="text-center mb-5 w-full lg:w-4/5 mx-auto">
                  <h1 className="text-xl font-medium border-b-[1px] border-lightGray mx-auto">
                    {details.eveningPracticeHeader}
                  </h1>
                  {schedule?.[language]?.offline?.sessions?.evening ?  <>
                      <p className="text-base">
                        {schedule[language].offline.sessions.evening?.days
                          ?.map(
                            (day, index) =>
                              <>
                                {day}
                                <ul className="mt-1 space-y-1 w-5/6 mx-auto">
                                  <li
                                    key={index}
                                    className="flex justify-between text-sm font-semibold mb-3"
                                  >
                                    <span>
                                      {schedule[language]?.offline?.sessions?.evening?.times?.[index]?.start || schedule[language]?.offline?.sessions?.evening?.times?.[0]?.start}-{schedule[language]?.offline?.sessions?.evening?.times?.[index]?.end || schedule[language]?.offline?.sessions?.evening?.times?.[0]?.end}
                                    </span>
                                    <span>
                                      {
                                        schedule[language]?.offline?.sessions?.evening?.times?.[index]?.activity || schedule[language]?.offline?.sessions?.evening?.times?.[0]?.activity

                                      }
                                    </span>
                                  </li>
                                </ul>
                              </>
                          )}
                      </p>
                    </> : (
                    <p className="text-base">{ToasterTrans[language].comingSoon}</p>
                  )}
                </div>

                {/* Location Section */}
                <div className="text-center mb-3 w-full">
                  <h1 className="text-xl font-medium border-b-[1px] border-lightGray w-5/6 mx-auto">
                    {details.locationHeader}
                  </h1>
                  <a
                    target="_blank"
                    href="https://maps.app.goo.gl/bbafodb4jTENrhcB7"
                    className="text-xl font-medium border-b-[1px] border-lightGray w-5/6 mx-auto"
                    rel="noopener noreferrer"
                  >
                    <p className="text-base text-blue-800">
                      {details.locationDetails}
                    </p>
                  </a>
                </div>
              </div>
            </div>

            {/* Booking Button */}
            <div className="w-full max-w-sm text-center mt-6">
              <SetmoreBooking
                buttonTextComponent={
                  <a
                    href="https://onceuponamat-com.setmore.com"
                    className="hover:bg-pink rounded-3xl text-white text-lg px-4 py-2 border-lightBeige border-8 bg-brown w-full block"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackPixelEvent("NavigateToBooking")}
                  >
                    {language === 'russian' ? details.registerForClass : "Coming soon ♥"}
                  </a>
                }
              />
            </div>
          </div>

          {/* Divider Line (Hidden on Mobile) */}
          <div className="hidden lg:block absolute left-1/2 top-0 h-full border-r-2 border-gray-300 transform -translate-x-1/2"></div>

          {/* Right Half - Pricing Section */}
          <div className="flex flex-col items-center w-full sm:w-5/6 mx-auto">
            <div className="text-center text-xl">{details.prices}</div>

            <div className="bg-beige rounded-3xl mt-5 w-full max-w-sm">
              <div className="bg-white m-4 p-7 pb-2 rounded-3xl">
                {/* Full Pricing List */}
                {[
                  { title: details.trial, price: "50 ₪", description: "" },
                  { title: details.dropInClass, price: "70 ₪", description: "" },
                  { title: details.basicPass, price: "250 ₪", description: language === "russian" ? "Пакет из 4-х занятий в месяц" : "4 classes a month pass" },
                  { title: details.standartPass, price: "350 ₪", description: language === "russian" ? "Пакет из 8-ми занятий в месяц" : "8 classes a month pass" },
                ].map((item, index) => (
                  <div key={index} className="text-center mb-5">
                    <h1 className="text-lg font-medium border-b-[1px] border-lightGray mx-auto">
                      {item.title} - {item.price}
                    </h1>
                    {item.description && <p className="text-base">{item.description}</p>}
                  </div>
                ))}
              </div>
            </div>

            {/* More Offers Button */}
            <p className="text-center mt-5 text-lg">{language === "russian" ? "Больше специальных предложений по запросу:" : "More special offers upon request:"}</p>
            <a className="hover:bg-pink rounded-3xl text-white text-lg px-4 py-2 mt-2 border-lightBeige border-8 bg-brown w-full max-w-sm text-center"
              href={language === "russian" ? "https://wa.link/aq5anl" : "https://wa.link/tofgs0"}
              target="_blank"
              rel="noopener noreferrer"
            >
              {language === 'russian' ? "Тык сюда ♥" : "Click here ♥"}
            </a>
          </div>
        </div>


      </div>
    </main>
  );
}
